import { groq } from 'next-sanity'
import { ButtonFields, seoFields } from '../partials/shared'

export const newsPageQuery = groq`{
  "newsPage": *[_type == "newsPage" && language == "en"][0] {
    headline,
    subHeadline,
    tag,
    title,
    featuredArticle->{
      _id,
      _type,
      publishedAt,
      title,
      description,
      duration,
      image{
        ...,
        "lqip": asset->metadata.lqip
      },
      "slug": slug.current,
      newsType->{
        title
      },
      link[0]{
				${ButtonFields}
      },
      ${seoFields}
    },
  },
  "newsTypes": *[_type == "newsType" && language == "en"] {
    title,
    "slug": slug.current,
  },
  "articles": *[
    _type == "newsPages"
    && publishedAt < coalesce($lastPublishedAt, now())
    && newsType->slug.current == coalesce($newsType, newsType->slug.current)
		&& language == "en"]
    | order(publishedAt desc) [0...12]  {
      _type,
      title,
      description,
      publishedAt,
      duration,
      image{
        ...,
        "lqip": asset->metadata.lqip
      },
      "slug": slug.current,
      newsType->{
        title,
        "slug":slug.current
      },
      _id,
      link[0]{
				${ButtonFields}
      }
  }
}`

export const newsSeoQuery = groq`*[_type == "newsPage" && language == "en"][0]{
	${seoFields}
}`
